/**React imports */
import React, { useEffect, Fragment } from 'react';
/**Router */
import { Link } from 'react-router-dom';
/**Css styles */



/**Transitions */
import Paper from '@material-ui/core/Paper';
import { Button, Fade, Card } from '@material-ui/core';



const CardService = (props) => {


    return (
        <Fragment>
            <div

                style={{
                    backgroundImage: `linear-gradient(
                    325deg,
                    rgba(88,163,0,1) 0%,
                    rgba(128,255,128,0.164) 100%
                    ),url(${(props.url)})`
                }}

                className="cardNote">
                <h1 style={{fontWeight:'bold',fontSize:'25px'}} className="titleCardNote">{props.titleCard}</h1>
                <Link style={{width:'100px',height:'40px',textAlign:'center',fontSize:'15px'}} className='btn btn-primary botonChido' to={props.view}>Consult</Link>
            </div>
        </Fragment>
    )

}


export default CardService;